import { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { useForm, Controller } from 'react-hook-form'
import { Store } from 'react-notifications-component'
import { Button, Form } from 'react-bootstrap'
import Markdown from '../../components/Markdown'
import notificationConfig from '../../config/notification'

const FaqSearch = ({ searchProps }) => {
  const { handleSearch, resetSearch, content, handleSuggestion, mergedFaqList } = searchProps
  const [suggestions, setSuggestions] = useState([])
  const [suggestionText, setSuggestionText] = useState(null)
  const {
    handleSubmit,
    control,
    watch,
    setValue,
    formState: { isSubmitting }
  } = useForm()
  const searchText = watch('faqSearchField')

  const onSubmit = (data) => {
    setSuggestions([])
    setSuggestionText(null)
    handleSearch(data.faqSearchField)
  }
  const onError = () =>
    Store.addNotification({
      title: content?.searchError || ' ',
      type: 'danger',
      ...notificationConfig
    })
  const clearSearch = () => {
    setValue('faqSearchField', '')
    setSuggestionText(null)
    resetSearch()
  }
  const formatSearchText = (text) => text?.toLowerCase()?.replace(/[^a-zA-Z0-9 ]/g, '') || ''

  useEffect(() => {
    if (searchText?.length > 2) {
      setSuggestions(mergedFaqList.filter((faq) => formatSearchText(faq.title)?.includes(formatSearchText(searchText))))
    } else {
      setSuggestions([])
      setSuggestionText(null)
    }
  }, [mergedFaqList, searchText])

  const handleSelectSuggestion = (suggestion) => {
    const formattedText = suggestion.title.replace(/[^a-zA-Z0-9 ]/g, '')
    handleSuggestion(suggestion.id)
    setValue('faqSearchField', formattedText)
    handleSearch(suggestion.title)
    setSuggestionText(formattedText)
  }

  return (
    <Form className="faq-search-form" onSubmit={handleSubmit(onSubmit, onError)}>
      <Controller
        control={control}
        name="faqSearchField"
        render={({ field: { onChange, onBlur, value } }) => (
          <Form.Group controlId="faqSearch" className="floating-group">
            <Form.Control
              onBlur={onBlur}
              value={value || ''}
              onChange={onChange}
              placeholder=" "
              disabled={isSubmitting}
            />
            <Form.Label>{content?.searchPlaceholder || ' '}</Form.Label>
          </Form.Group>
        )}
      />
      {searchText?.length > 0 && (
        <Button variant="link" className="clear-btn text-secondary" onClick={clearSearch}>
          <i className="material-icons clear-icon">highlight_off</i>
        </Button>
      )}
      <Button type="submit" variant="link" className="submit-btn">
        <i className="material-icons search-icon">search</i>
      </Button>
      {suggestions.length > 0 && suggestionText !== searchText && (
        <div className="search-autofill bg-white rounded shadow py-2">
          {suggestions.map((suggestion) => (
            <a
              key={suggestion.id}
              href={`#faqItem_${suggestion.id}`}
              className="suggestion-link d-flex"
              onClick={() => handleSelectSuggestion(suggestion)}
            >
              <span className="flex-fill px-3 py-2">
                <Markdown>{suggestion.title}</Markdown>
              </span>
              <i className="material-icons suggestion-icon pe-3">north_west</i>
            </a>
          ))}
        </div>
      )}
    </Form>
  )
}

FaqSearch.propTypes = {
  searchProps: PropTypes.instanceOf(Object).isRequired
}

export default FaqSearch
